import { render, staticRenderFns } from "./something-went-wrong-container.vue?vue&type=template&id=380d9f40"
import script from "./something-went-wrong-container.vue?vue&type=script&lang=js"
export * from "./something-went-wrong-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports